import React, { useEffect, useState } from 'react';
import { queryApplicationResults } from 'src/api/query-logic/query-dashboard';
import { queryE2eForm } from 'src/api/query-logic/query-e2e-form';
import NewBreadDumbLenderResponseTable from 'src/e2e-redesign/views-bread/BreadLenderResponses/bread-new-dumb-lender-response-table';
import { GroupedOfferI } from 'src/e2e-redesign/views/LenderResponses/logic/provider-response-logic';
import NewDumbLenderResponseTable from 'src/e2e-redesign/views/LenderResponses/new-dumb-lender-response-table';
import { LendersI } from 'src/interfaces/lenders.interfaces';
import {
  ApplicationContractStatusE,
  ApplicationSubmissionStateDto,
  AppSubLenderResponseE,
  LenderOffersI,
} from 'src/interfaces/submissions.interfaces';
import { BREAD_LENDER_ID } from 'src/utils/bread-e2e-constants';

interface E2eDashboardResponseHandlerProps {
  groupedOffer: GroupedOfferI;
  index: number;
}

const E2eDashboardResponseHandler: React.FC<E2eDashboardResponseHandlerProps> = (
  props: E2eDashboardResponseHandlerProps,
) => {
  const { groupedOffer, index } = props;
  const offer = groupedOffer.offers[0];
  const [showEcoa, setShowEcoa] = useState<boolean>(false);
  const offerDetails: LenderOffersI | undefined = offer?.offer_details;
  const submissionDetails: ApplicationSubmissionStateDto = offer.sub_details;
  const offerLender: LendersI = offer.lender;
  const lenderDisclosures = offer.lender_disclosures;
  const [selectedOffer, setSelectedOffer] = useState<string>('');
  const isPending = submissionDetails.lender_response === AppSubLenderResponseE.pending;
  const isSigned =
    submissionDetails.contract_status === ApplicationContractStatusE.signed ||
    submissionDetails.contract_status === ApplicationContractStatusE.funded;
  //TODO We don't have a good way of identifying app result by applicant so I am doing it per lender with offers here. this and the server needs rewritten to get all app_results for an applicant
  const { data } = queryApplicationResults({
    reqData: { params: { lender_id: submissionDetails.lender_id, fp_unique_id: offerDetails?.fp_unique_id } },
    queryKey: [`${submissionDetails.lender_id}-${offerDetails?.fp_unique_id}`],
    enabled: isSigned,
  });

  useEffect(() => {
    const showEcoaStatuses = [AppSubLenderResponseE.rejected, AppSubLenderResponseE.soft_decline];
    if (showEcoaStatuses.includes(submissionDetails.lender_response)) {
      setShowEcoa(true);
    }
  }, [submissionDetails]);

  const showProperLenderResponse = () => {
    if (submissionDetails.lender_id == BREAD_LENDER_ID) {
      return (
        <NewBreadDumbLenderResponseTable
          submissionDetails={submissionDetails}
          index={index}
          offerLender={offerLender}
          lenderDisclosures={lenderDisclosures}
          offerDetails={offerDetails}
          offer={offer}
          applicationResult={data}
          isPending={isPending}
          selectedOffer={selectedOffer}
          showEcoa={showEcoa}
          // not including
          redirectUrl={undefined}
          showUpdateStatus={false}
          handleUpdateStatus={async () => {}}
          handleAcceptAndProceed={() => {}}
          handleOfferSelection={() => {}}
          disableActions={true}
        />
      );
    } else {
      return (
        <>
          <NewDumbLenderResponseTable
            submissionDetails={submissionDetails}
            index={index}
            offerLender={offerLender}
            lenderDisclosures={lenderDisclosures}
            offerDetails={offerDetails}
            offer={offer}
            applicationResult={data}
            isPending={isPending}
            selectedOffer={selectedOffer}
            showEcoa={showEcoa}
            // not including
            redirectUrl={undefined}
            showUpdateStatus={false}
            handleUpdateStatus={async () => {}}
            handleAcceptAndProceed={() => {}}
            handleOfferSelection={() => {}}
            disableActions={true}
          />
        </>
      );
    }
  };
  return showProperLenderResponse();
};

export default E2eDashboardResponseHandler;
